
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.401","height":"19.823"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3.734.58H.501v3.068M12.376 3.733V.5H9.309M.5 9.392v3.233h3.067"}}),_c('g',{attrs:{"transform":"translate(6.719 6.961)"}},[_c('path',{attrs:{"d":"M0 9.009l.012 3.345h3.344M7.836 12.36l3.345-.012V9.004M11.181 3.35L11.169.005H7.825M3.344 0L-.001.012v3.344"}}),_c('line',{attrs:{"y2":"6.364","transform":"translate(5.59 2.64)"}}),_c('line',{attrs:{"x1":"5.372","transform":"translate(2.904 5.791)"}})])])])
          )
        }
      }
    